import { ITerm } from '../../../interfaces/scheduler_interfaces';
import { TermProgramInfoModel } from '../models/term_program_info_model';
import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

export type LoadProgramTermInfoCommand = (termId: ITerm['id']) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'loadProgramTermInfoCommand',
    ($http: ng.IHttpService, defineCommandORM: ICommand, log: any, ngTermProgramInfoModel: TermProgramInfoModel) => {
      'use strict';

      return defineCommandORM('loadProgramTermInfoCommand', (deferred: ng.IDeferred<any[]>, termId: number) => {
        $http
          .get(`/reg/term/${termId}/`, { cache: false })
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngTermProgramInfoModel.write({
              term: _4.first(_4.toArray(data.term)),
              program: _4.first(_4.toArray(data.program))
            });
            deferred.resolve();
          })
          .catch((e: ng.IHttpPromiseCallbackArg<any>) => {
            log.issue('failed to load program and term information');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/commands/get_program_and_term_info_command.ts